import React from "react"
import { pill, pillText, pillIcon, active } from './pill.module.css'

const Pill = ({ icon: IconComponent, label, isActive, onClick }) => {
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            onClick();
        }
    };
    return (
        <div
            className={isActive ? `${pill} ${active}` : pill}
            onClick={onClick}
            onKeyDown={handleKeyDown}
        >
            {IconComponent && <IconComponent className={pillIcon} fill={isActive ? '#FFF' : '#4F4F4F'} />}
            <span className={pillText}>{label}</span>
        </div>
    )
}

export default Pill
